import { FlexiButton } from "@flexinet/ui-components";
import { MdReplyAll } from "react-icons/md";

interface ReplyAllButtonProps {
    onClick: () => void;
}

export const ReplyAllButton = ({ onClick }: ReplyAllButtonProps) => {
    return (
        <FlexiButton variant={'outline'} leftSection={<MdReplyAll />} onClick={onClick}>
            Reply All
        </FlexiButton>
    );
};
